import React from "react";
import type { LoadingSpinnerProps } from "./LoadingSpinner.types";

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = "md",
  color = "primary",
  className = "",
}) => {
  const sizeClasses = {
    sm: "h-4 w-4",
    md: "h-6 w-6",
    lg: "h-8 w-8",
    xl: "h-12 w-12",
  }[size] ?? "h-6 w-6";

  const colorClasses = {
    primary: "border-brand",
    secondary: "border-white/40",
    white: "border-white",
    gray: "border-white/30",
  }[color] ?? "border-brand";

  return (
    <div
      className={`animate-spin rounded-full border-2 border-t-transparent ${sizeClasses} ${colorClasses} ${className}`}
      role="status"
      aria-label="Loading"
    />
  );
};
